import React from 'react';
import {AsyncComponent} from "../../components/router/async-component";

const BootstrapModuleAsyncComponent = AsyncComponent(async () => import('./bootstrap-module' /* webpackChunkName: "bootstrap-module" */ ));

export const BootstrapModuleAsync = (props) => {
  return <BootstrapModuleAsyncComponent {...props}/>
}
